import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9b43378"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold m-redemption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_questionnaire = _resolveComponent("m-questionnaire")!
  const _component_m_discount = _resolveComponent("m-discount")!
  const _component_m_q_r_code = _resolveComponent("m-q-r-code")!
  const _component_m_q_r_code_with_questions = _resolveComponent("m-q-r-code-with-questions")!
  const _component_m_url = _resolveComponent("m-url")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.campaignActionType === _ctx.CampaignAction.QUESTION)
      ? (_openBlock(), _createBlock(_component_m_questionnaire, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.state.campaignActionType === _ctx.CampaignAction.SHOPIFY_DISCOUNT)
      ? (_openBlock(), _createBlock(_component_m_discount, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.state.campaignActionType === _ctx.CampaignAction.CODE)
      ? (_openBlock(), _createBlock(_component_m_q_r_code, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.state.campaignActionType === _ctx.CampaignAction.CODE_WITH_QUESTIONS)
      ? (_openBlock(), _createBlock(_component_m_q_r_code_with_questions, { key: 3 }))
      : _createCommentVNode("", true),
    (
        _ctx.state.campaignActionType === _ctx.CampaignAction.SHOPIFY_URL ||
        _ctx.state.campaignActionType === _ctx.CampaignAction.SHOPIFY_DELAYED
      )
      ? (_openBlock(), _createBlock(_component_m_url, { key: 4 }))
      : _createCommentVNode("", true)
  ]))
}